export const pageTitle = 'Ganti Password';
export const pageDescription = 'Atur ulang password Anda dengan mudah dan aman.';

export const formResetPassword = {
  password: {
    label: 'Password Baru',
    placeholder: 'Masukkan password baru',
  },
  confirmPassword: {
    label: 'Konfirmasi Password',
    placeholder: 'Masukkan password baru',
  },

  rules: {
    minCharacter: (min) => `Minimal ${min} karakter`,
    maxCharacter: (max) => `Maksimal ${max} karakter`,
    hasSpecialCharacter: 'Gunakan 1 karakter khusus (Contoh: * - , !)',
    hasUpperCase: 'Gunakan minimal 1 huruf kapital (Contoh: A B C)',
    hasLowerCase: 'Gunakan minimal 1 huruf kecil (Contoh: a b c)',
    hasNumber: 'Gunakan minimal 1 angka (Contoh: 1 2 3)',
  },

  error: {
    passwordRequired: 'Password harus diisi',
    passwordNotMatch: 'Password yang kamu masukkan tidak sama ',
  },

  button: {
    send: 'Ganti Password',
  },
};

export const alertSuccess = {
  title: 'Password berhasil diganti! 🎉',
  description: 'Password baru kamu sudah siap digunakan. Sekarang akunmu lebih aman! Silakan login dengan password baru untuk melanjutkan.',
  action: 'Login sekarang',
};
